<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <form-wrapper :sections="[{ id: 'name', label: 'Name' }]" hideNav>
            <org-unit-form-name id="name" v-model="orgUnit.name" :error="displayFirstError(validation.name.$errors)">
            </org-unit-form-name>

            <vx-sticky-footer>
                <vx-button :href="`/settings/teams/${teamId}#/org-units`" class="w-20" size="lg" color="muted">
                    Cancel
                </vx-button>
                <vx-button
                    @click="submit()"
                    :disabled="!onCorporate() && roleOnCurrentOrgUnit !== 'admin'"
                    data-test="submit-button"
                    class="grow"
                    size="lg"
                    color="primary"
                    :loading="processing"
                >
                    Update Organizational Unit
                </vx-button>
            </vx-sticky-footer>
        </form-wrapper>
    </org-unit-details>
</template>

<script setup>
import { faSquareArrowUpLeft } from '@fortawesome/pro-solid-svg-icons';
import { VxButton, VxStickyFooter } from '@voxie/frontend-components';
import OrgUnitDetails from './OrgUnitDetails.vue';
import OrgUnitFormName from './OrgUnitFormName.vue';
import { maxLength, required } from '@vuelidate/validators';
import { groupAndOrgUnitName, displayFirstError } from '~/utils/validation';
import { useOrgUnitDetails } from './useOrgUnitDetails';
import FormWrapper from '~/components/general/FormWrapper.vue';
import { orgUnitsClient } from '~/services';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import { useFormSubmission } from '~/composables/useFormSubmission.js';

const teamId = Spark.state.currentTeam.id;
const { onCorporate, roleOnCurrentOrgUnit } = useCurrentGroup();

const props = defineProps({
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const { orgUnit } = useOrgUnitDetails();

const save = async () => {
    await orgUnitsClient.updateOrgUnit(teamId, props.orgUnitId, {
        name: orgUnit.value.name,
    });
};

const { submit, processing, validation } = useFormSubmission({
    data: orgUnit,
    validation: {
        name: {
            required,
            maxLength: maxLength(80),
            format: groupAndOrgUnitName,
        },
    },
    submit: save,
    preserveScroll: () => Boolean(props.orgUnitId),
    notification: () => ({
        message: 'Organizational Unit updated',
        action: {
            icon: faSquareArrowUpLeft,
            label: 'Back to OUs',
            href: `/settings/teams/${teamId}#/org-units`,
        },
    }),
});
</script>
